// Reviews auto-carousel: scrolls the review rail one card at a time every
// 6 seconds, pauses on hover / focus / pointer interaction, respects
// prefers-reduced-motion and Save-Data. Zero dependencies, no framework.
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  if (reduced || saveData) return;

  document.querySelectorAll('.oaa-reviews-section [data-rail-track]').forEach((track) => {
    if (!(track instanceof HTMLElement)) return;
    let timer = null;
    let paused = false;

    const stepPx = () => {
      const first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.9;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return first.getBoundingClientRect().width + gap;
    };

    const tick = () => {
      if (paused) return;
      const step = stepPx();
      const max = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= max) {
        track.scrollTo({left: 0, behavior: 'smooth'});
      } else {
        track.scrollBy({left: step, behavior: 'smooth'});
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(tick, 6000);
    };
    const stop = () => {
      if (timer) { window.clearInterval(timer); timer = null; }
    };

    // Only auto-play on mobile / tablet where the rail actually scrolls.
    // On desktop the reviews are laid out as a static grid — no motion needed.
    const isScrollable = () => track.scrollWidth > track.clientWidth + 8;
    const maybeStart = () => (isScrollable() ? start() : stop());

    ['pointerenter', 'focusin', 'touchstart'].forEach((ev) =>
      track.addEventListener(ev, () => { paused = true; }, {passive: true})
    );
    ['pointerleave', 'focusout', 'touchend'].forEach((ev) =>
      track.addEventListener(ev, () => { paused = false; }, {passive: true})
    );

    // IntersectionObserver: only autoplay while the rail is on screen.
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) maybeStart(); else stop();
    }, {threshold: 0.35});
    io.observe(track);

    // Recompute if the layout switches between grid and scroll (rotate, resize).
    let raf = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(maybeStart);
    }, {passive: true});
  });
})();
